export interface ManhwaCategory {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: ManhwaCategory[] = [
  { slug: "romance", name: "恋爱言情", description: "甜蜜浪漫的韩国恋爱漫画", icon: "ri-heart-line" },
  { slug: "fantasy", name: "奇幻冒险", description: "充满想象力的奇幻世界", icon: "ri-magic-line" },
  { slug: "action", name: "热血动作", description: "燃爆全场的动作漫画", icon: "ri-flashlight-line" },
  { slug: "comedy", name: "搞笑日常", description: "轻松搞笑的日常故事", icon: "ri-emotion-laugh-line" },
  { slug: "thriller", name: "悬疑惊悚", description: "紧张刺激的悬疑之作", icon: "ri-ghost-line" },
  { slug: "drama", name: "剧情人生", description: "感人至深的剧情故事", icon: "ri-film-line" },
  { slug: "historical", name: "古风历史", description: "穿越时空的历史画卷", icon: "ri-ancient-gate-line" },
  { slug: "school", name: "校园青春", description: "青春洋溢的校园故事", icon: "ri-book-open-line" },
];

export interface ManhwaItem {
  id: string;
  title: string;
  author: string;
  category: string;
  cover: string;
  description: string;
  rating: number;
  views: number;
  chapters: number;
  status: "连载中" | "已完结";
  tags: string[];
  updatedAt: string;
}

export const popularManhwa: ManhwaItem[] = [
  {
    id: "mh-001",
    title: "我的ID是江南美人",
    author: "淇萌琪",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20cover%20art%20featuring%20a%20beautiful%20young%20woman%20with%20long%20dark%20hair%20in%20a%20university%20setting%2C%20soft%20romance%20atmosphere%2C%20clean%20minimal%20illustration%20style%20with%20warm%20pink%20tones%2C%20manga%20panel%20aesthetic%2C%20simple%20gradient%20background&width=400&height=560&seq=manhwa-cover-001&orientation=portrait",
    description: "因外貌自卑的女孩通过整容手术变成校园女神，却发现美丽背后隐藏着更多的烦恼与挑战。",
    rating: 4.8,
    views: 2356000,
    chapters: 156,
    status: "已完结",
    tags: ["恋爱", "校园", "成长"],
    updatedAt: "2026-07-28",
  },
  {
    id: "mh-002",
    title: "全知读者视角",
    author: "sing N song",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20featuring%20a%20young%20man%20with%20glasses%20holding%20a%20glowing%20book%20in%20a%20dark%20apocalyptic%20setting%2C%20fantasy%20drama%20style%2C%20mysterious%20atmosphere%2C%20clean%20illustration%20with%20blue-gray%20tones%2C%20minimalist%20composition%20with%20dramatic%20lighting&width=400&height=560&seq=manhwa-cover-002&orientation=portrait",
    description: "当整个世界变成他读过的小说，唯一知晓结局的他将如何在这个末日世界中生存下去？",
    rating: 4.9,
    views: 5120000,
    chapters: 210,
    status: "连载中",
    tags: ["奇幻", "末日", "系统"],
    updatedAt: "2026-08-04",
  },
  {
    id: "mh-003",
    title: "女神降临",
    author: "猫咪",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20featuring%20a%20beautiful%20young%20woman%20with%20makeup%20transformation%20theme%2C%20before%20and%20after%20concept%2C%20soft%20glamorous%20style%2C%20warm%20peach%20and%20pink%20color%20palette%2C%20clean%20illustration%20with%20sparkle%20effects%2C%20minimal%20simple%20background&width=400&height=560&seq=manhwa-cover-003&orientation=portrait",
    description: "化妆技术一流的她白天是校园女神，晚上卸妆后的素颜却无人知晓。一场关于真实与伪装的故事。",
    rating: 4.7,
    views: 1890000,
    chapters: 223,
    status: "已完结",
    tags: ["恋爱", "校园", "美妆"],
    updatedAt: "2026-06-15",
  },
  {
    id: "mh-004",
    title: "我独自升级",
    author: "Chugong",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=Korean%20action%20webtoon%20cover%20featuring%20a%20powerful%20male%20hunter%20with%20dark%20armor%20and%20glowing%20eyes%20surrounded%20by%20shadow%20warriors%2C%20epic%20fantasy%20art%20style%2C%20dramatic%20dark%20atmosphere%20with%20purple%20and%20black%20tones%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-004&orientation=portrait",
    description: "E级猎人成振宇在一次生死危机中觉醒独特能力，从此开启了独自升级成为最强猎人的传奇之路。",
    rating: 4.9,
    views: 8900000,
    chapters: 179,
    status: "已完结",
    tags: ["动作", "奇幻", "升级"],
    updatedAt: "2026-08-01",
  },
  {
    id: "mh-005",
    title: "社内相亲",
    author: "海潮",
    category: "comedy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romantic%20comedy%20webtoon%20cover%20featuring%20a%20young%20couple%20in%20office%20attire%20awkwardly%20facing%20each%20other%20in%20a%20corporate%20setting%2C%20light%20humorous%20style%2C%20warm%20yellow%20and%20cream%20tones%2C%20clean%20minimal%20illustration&width=400&height=560&seq=manhwa-cover-005&orientation=portrait",
    description: "为替闺蜜赴一场相亲，她假扮成另一个人，却发现相亲对象竟是自己的公司社长！",
    rating: 4.6,
    views: 1560000,
    chapters: 124,
    status: "已完结",
    tags: ["恋爱", "搞笑", "职场"],
    updatedAt: "2026-05-20",
  },
  {
    id: "mh-006",
    title: "甜蜜家园",
    author: "金坎比",
    category: "thriller",
    cover: "https://readdy.ai/api/search-image?query=Korean%20thriller%20webtoon%20cover%20featuring%20a%20lonely%20teenager%20standing%20in%20a%20dark%20apartment%20hallway%20with%20monster%20shadows%20lurking%2C%20horror%20aesthetic%2C%20dark%20moody%20atmosphere%20with%20red%20accents%2C%20clean%20graphic%20illustration&width=400&height=560&seq=manhwa-cover-006&orientation=portrait",
    description: "孤独少年搬进新公寓后，世界突然爆发怪物危机。被困在公寓中的居民们为生存而战斗。",
    rating: 4.8,
    views: 3450000,
    chapters: 140,
    status: "已完结",
    tags: ["悬疑", "恐怖", "生存"],
    updatedAt: "2026-07-10",
  },
  {
    id: "mh-007",
    title: "她的私生活",
    author: "金成妍",
    category: "drama",
    cover: "https://readdy.ai/api/search-image?query=Korean%20drama%20webtoon%20cover%20featuring%20a%20professional%20woman%20secretly%20holding%20idol%20merchandise%20behind%20her%20back%20in%20an%20art%20gallery%2C%20sophisticated%20style%2C%20warm%20brown%20and%20beige%20tones%2C%20clean%20elegant%20illustration&width=400&height=560&seq=manhwa-cover-007&orientation=portrait",
    description: "美术馆策展人表面上是完美的职场女性，私下却是狂热的偶像粉丝。双重生活的秘密即将曝光。",
    rating: 4.5,
    views: 980000,
    chapters: 98,
    status: "已完结",
    tags: ["剧情", "恋爱", "职场"],
    updatedAt: "2026-04-30",
  },
  {
    id: "mh-008",
    title: "剑尊归来",
    author: "Lico",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20fantasy%20webtoon%20cover%20featuring%20a%20swordsman%20with%20flowing%20robes%20and%20a%20glowing%20sword%20in%20ancient%20Chinese-style%20landscape%2C%20elegant%20ink%20wash%20style%2C%20teal%20and%20gold%20accents%2C%20clean%20minimal%20composition&width=400&height=560&seq=manhwa-cover-008&orientation=portrait",
    description: "天下第一剑尊在百年后重生，面对物是人非的江湖，他能否再次登上巅峰？",
    rating: 4.7,
    views: 2780000,
    chapters: 167,
    status: "连载中",
    tags: ["奇幻", "武侠", "重生"],
    updatedAt: "2026-08-03",
  },
];

export const latestManhwa: ManhwaItem[] = [
  {
    id: "mh-009",
    title: "恶役只有死亡结局",
    author: "권겨을",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20webtoon%20cover%20featuring%20a%20villainess%20noblewoman%20in%20elegant%20gown%20with%20determined%20expression%20in%20a%20royal%20palace%20setting%2C%20dramatic%20romance%20style%2C%20deep%20red%20and%20gold%20tones%2C%20clean%20illustration&width=400&height=560&seq=manhwa-cover-009&orientation=portrait",
    description: "穿越成为游戏中的反派千金，她必须在各种死亡结局中找出唯一的生存之路。",
    rating: 4.6,
    views: 1200000,
    chapters: 89,
    status: "连载中",
    tags: ["奇幻", "恋爱", "穿越"],
    updatedAt: "2026-08-05",
  },
  {
    id: "mh-010",
    title: "废太子逆袭记",
    author: "柳川",
    category: "historical",
    cover: "https://readdy.ai/api/search-image?query=Korean%20historical%20fantasy%20webtoon%20cover%20featuring%20a%20young%20crown%20prince%20in%20traditional%20Korean%20royal%20attire%20standing%20proudly%20in%20a%20palace%20courtyard%2C%20elegant%20period%20style%2C%20warm%20amber%20and%20jade%20green%20tones%2C%20clean%20illustration&width=400&height=560&seq=manhwa-cover-010&orientation=portrait",
    description: "被废黜的太子重生回到少年时期，带着前世记忆，他誓要改写命运，夺回属于自己的一切。",
    rating: 4.5,
    views: 890000,
    chapters: 67,
    status: "连载中",
    tags: ["古风", "重生", "权谋"],
    updatedAt: "2026-08-05",
  },
  {
    id: "mh-011",
    title: "校园怪谈",
    author: "黑夜",
    category: "school",
    cover: "https://readdy.ai/api/search-image?query=Korean%20school%20mystery%20webtoon%20cover%20featuring%20students%20with%20flashlights%20exploring%20a%20dark%20school%20corridor%20at%20night%2C%20mysterious%20spooky%20atmosphere%2C%20cool%20blue-gray%20tones%20with%20yellow%20flashlight%20accents%2C%20clean%20illustration&width=400&height=560&seq=manhwa-cover-011&orientation=portrait",
    description: "新转学生发现学校隐藏着不为人知的秘密，每到夜晚，校园里就会出现诡异的怪谈现象。",
    rating: 4.4,
    views: 670000,
    chapters: 45,
    status: "连载中",
    tags: ["校园", "悬疑", "青春"],
    updatedAt: "2026-08-04",
  },
  {
    id: "mh-012",
    title: "九尾狐传",
    author: "金银姬",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20webtoon%20cover%20featuring%20a%20beautiful%20nine-tailed%20fox%20spirit%20woman%20with%20ethereal%20white%20hair%20in%20modern%20Seoul%20cityscape%2C%20magical%20atmosphere%2C%20soft%20silver%20and%20lavender%20tones%2C%20clean%20minimal%20illustration&width=400&height=560&seq=manhwa-cover-012&orientation=portrait",
    description: "千年九尾狐在现代都市中邂逅命中注定之人，一场跨越时空的奇幻恋歌就此展开。",
    rating: 4.7,
    views: 1560000,
    chapters: 112,
    status: "连载中",
    tags: ["奇幻", "恋爱", "神话"],
    updatedAt: "2026-08-02",
  },
];

export const allManhwa: ManhwaItem[] = [...popularManhwa, ...latestManhwa];

export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  author: string;
  cover: string;
  excerpt: string;
  content: string;
  publishDate: string;
  readTime: number;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: "art-001",
    title: "2026年最值得期待的十部韩国漫画新作",
    slug: "2026-most-anticipated-new-korean-manhwa",
    category: "news",
    author: "韩漫编辑部",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20art%20display%20wall%20featuring%20multiple%20manhwa%20panels%20arranged%20in%20gallery%20style%20with%20soft%20lighting%2C%20modern%20exhibition%20space%2C%20colorful%20comic%20panels%2C%20clean%20minimal%20composition%2C%20warm%20ambient%20light&width=800&height=450&seq=article-cover-001&orientation=landscape",
    excerpt: "2026年韩国漫画界迎来了众多令人期待的新作，从奇幻冒险到浪漫爱情，这份清单为你盘点年度必看韩漫。",
    content: `<p>2026年对于韩国漫画爱好者来说，注定是一个丰收之年。众多知名作家携新作回归，新人作家也带来了令人耳目一新的作品。</p>

<h2>一、《时光倒流的咖啡馆》</h2>
<p>由《我的ID是江南美人》作者淇萌琪带来的全新力作，讲述了一间神秘咖啡馆的故事。在这里，客人们可以通过喝一杯特调咖啡，回到过去某个重要的时刻。作品以细腻的笔触描绘了不同人物的人生抉择，画风温暖治愈，预计将于2026年3月正式连载。</p>

<h2>二、《末日生存法则》</h2>
<p>继《我独自升级》大获成功后，Chugong带来了全新的末日题材作品。故事设定在突如其来的全球灾难之后，幸存者们必须在废墟中寻找生存的希望。作品融合了生存、悬疑和人性探讨，画面对末日场景的描绘极具视觉冲击力。</p>

<h2>三、《月光少年》</h2>
<p>新人作家李恩珠的出道作品，讲述了一位只有在月光下才能发挥超能力的少年，在白天的普通高中生活和夜晚的英雄使命之间来回切换。作品将校园日常与奇幻元素巧妙结合，画风清新独特。</p>

<h2>四、《宫廷绣娘》</h2>
<p>古风题材再添力作。现代服装设计师意外穿越到古代宫廷，凭借精湛的刺绣技艺在宫廷中立足。作品中大量精美的韩服设计令人赏心悦目，对传统工艺的还原也十分考究。</p>

<h2>五、《星际快递员》</h2>
<p>科幻题材在韩漫中属于小众类别，但《星际快递员》有望打破这一刻板印象。故事设定在未来宇宙时代，主人公是一名穿梭于不同星球之间的快递员，每一单快递背后都隐藏着独特的星际故事。</p>

<h2>展望2026</h2>
<p>可以预见，2026年韩漫市场将继续保持强劲增长。更多元化的题材、更精良的制作和更广泛的传播渠道，都将推动韩国漫画走向更广阔的舞台。</p>`,
    publishDate: "2026-08-01",
    readTime: 8,
    tags: ["新作推荐", "2026", "韩漫资讯"],
  },
  {
    id: "art-002",
    title: "从韩漫看韩国年轻人的恋爱观变迁",
    slug: "korean-young-adult-love-view-through-manhwa",
    category: "analysis",
    author: "文化观察室",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20panels%20collage%20with%20couples%20in%20various%20romantic%20settings%20like%20cafe%20street%20and%20park%2C%20soft%20romantic%20atmosphere%2C%20warm%20pink%20and%20cream%20tones%2C%20clean%20minimal%20flat%20lay%20composition&width=800&height=450&seq=article-cover-002&orientation=landscape",
    excerpt: "通过近年热门的韩国恋爱漫画，我们可以一窥韩国当代年轻人恋爱观念的变化趋势。",
    content: `<p>韩国漫画，尤其是网络漫画（Webtoon），早已超越了单纯的娱乐功能，成为反映社会文化的一面镜子。通过分析近年来的热门恋爱漫画，我们可以清晰地看到韩国年轻人恋爱观念的变迁。</p>

<h2>从"白马王子"到"共同成长"</h2>
<p>早期的韩漫恋爱作品中，女主角往往是被动等待拯救的角色。而近年的作品如《女神降临》《她的私生活》等，女主角拥有独立的事业和追求，爱情被视为人生的一部分而非全部。这种转变反映了韩国社会女性地位的提升和自我意识的觉醒。</p>

<h2>职场恋爱的现实化描绘</h2>
<p>《社内相亲》等以职场为背景的恋爱漫画，不再回避职场恋情的复杂性。作品中对办公室政治、年龄差距、社会阶层差异的刻画，展现了韩国年轻人面对的现实困境。这些漫画不仅仅是浪漫故事，更是对当代社会关系的深刻观察。</p>

<h2>多元化的感情表达</h2>
<p>近年来，韩漫中感情表达的方式变得更加多样化。从传统的含蓄内敛到如今的直率表达，从单一的异性恋爱到多元感情观的呈现，韩漫在情感描绘上的边界不断拓展。</p>

<h2>数字化时代的爱情</h2>
<p>社交媒体、即时通讯、网络约会——这些数字时代的产物也频繁出现在韩漫中。作品中对"已读不回"的焦虑、网络形象与现实的反差等话题的探讨，真实地反映了Z世代年轻人的感情体验。</p>

<h2>总结</h2>
<p>韩漫作为文化产品，既是时代变迁的记录者，也是社会观念的塑造者。通过阅读这些作品，我们不仅能享受精彩的故事，还能深入理解韩国社会文化的演变脉络。</p>`,
    publishDate: "2026-07-25",
    readTime: 10,
    tags: ["文化分析", "恋爱观", "社会观察"],
  },
  {
    id: "art-003",
    title: "韩漫入门指南：新手必读的经典作品推荐",
    slug: "korean-manhwa-beginner-guide-must-read-classics",
    category: "guide",
    author: "韩漫推荐官",
    cover: "https://readdy.ai/api/search-image?query=Stack%20of%20colorful%20Korean%20webtoon%20books%20and%20tablet%20displaying%20digital%20comics%20on%20a%20cozy%20reading%20nook%20with%20warm%20lamp%20light%2C%20comfortable%20reading%20atmosphere%2C%20soft%20warm%20tones%2C%20clean%20minimal%20composition&width=800&height=450&seq=article-cover-003&orientation=landscape",
    excerpt: "刚接触韩国漫画不知道从何看起？这份入门指南为你精选了不同类型中最具代表性的经典韩漫。",
    content: `<p>如果你刚刚踏入韩国漫画的世界，面对琳琅满目的作品不知从何选择，那么这份入门指南将为你指明方向。我们根据不同类型为你精选了最具代表性的经典作品。</p>

<h2>奇幻冒险类入坑推荐</h2>
<p><strong>《我独自升级》</strong>——如果你喜欢热血战斗和主角成长的快感，这部作品绝对不能错过。精致的画风和紧凑的剧情让它成为近年来最受欢迎的韩漫之一。故事讲述E级猎人在生死关头觉醒独特能力后不断升级变强，最终成为最强存在的历程。</p>

<p><strong>《全知读者视角》</strong>——这是一部设定新颖的奇幻作品。当整个世界变成了他读过的小说，唯一知晓结局的男主角将如何改变命运？作品巧妙融合了末日生存和文学致敬的元素。</p>

<h2>恋爱言情类入坑推荐</h2>
<p><strong>《我的ID是江南美人》</strong>——探讨外貌与自信的深度恋爱作品。女主角通过整容改变外貌后，却发现真正的自信来自于内心。作品在浪漫故事之外，传递了积极的价值观。</p>

<p><strong>《女神降临》</strong>——化妆技术一流的女主角在"女神"和"素颜"之间切换的趣味设定，加上温暖的成长故事，让这部作品收获了众多粉丝。</p>

<h2>悬疑惊悚类入坑推荐</h2>
<p><strong>《甜蜜家园》</strong>——改编自同名网络漫画的Netflix热门剧集原作。故事紧张刺激，对人性的探讨深刻有力。如果你喜欢黑暗风格和生存题材，这部作品会给你带来极佳的阅读体验。</p>

<h2>阅读建议</h2>
<p>建议新手读者可以先从已完结的作品开始阅读，这样不用担心追更的焦虑。同时，不同平台的翻译质量参差不齐，选择正规渠道阅读能获得更好的体验。</p>`,
    publishDate: "2026-07-18",
    readTime: 12,
    tags: ["入门指南", "经典推荐", "新手指南"],
  },
];

export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: "韩漫漫画网的漫画都是免费的吗？",
    answer: "是的，韩漫漫画网上所有漫画内容均免费提供阅读。我们致力于为广大漫画爱好者提供优质的免费阅读服务，无需任何付费即可畅享海量韩国漫画资源。",
  },
  {
    question: "网站上的漫画多久更新一次？",
    answer: "我们与多家韩国漫画平台保持密切合作，热门连载漫画通常在原作更新后24小时内同步上线。具体更新频率取决于各作品的连载计划，一般在每周固定时间更新1-2话。",
  },
  {
    question: "如何在手机上阅读漫画？",
    answer: "韩漫漫画网采用响应式设计，完美适配手机、平板和电脑等设备。您只需在手机浏览器中打开我们的网站，即可获得流畅的移动阅读体验，无需下载任何App。",
  },
  {
    question: "网站支持哪些类型的漫画筛选？",
    answer: "我们提供恋爱言情、奇幻冒险、热血动作、搞笑日常、悬疑惊悚、剧情人生、古风历史、校园青春等八大分类，您可以根据喜好快速筛选感兴趣的漫画类型。",
  },
  {
    question: "遇到阅读问题如何联系客服？",
    answer: "您可以通过关于我们页面上的联系方式或提交联系表单与我们取得联系。我们会在24小时内回复您的咨询，节假日可能略有延迟。",
  },
];

export interface Reputation {
  name: string;
  role: string;
  content: string;
  rating: number;
  avatar: string;
}

export const reputations: Reputation[] = [
  {
    name: "漫画控小王",
    role: "资深漫画读者",
    content: "韩漫漫画网的更新速度真的很快！很多热门作品都是第一时间同步，画质也很清晰。最主要是完全免费，对于我这种每天要看十几话的漫画迷来说简直太友好了。",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20man%20avatar%20portrait%20with%20friendly%20smile%2C%20casual%20style%2C%20clean%20minimal%20studio%20lighting%2C%20simple%20warm%20background&width=100&height=100&seq=avatar-001&orientation=squarish",
  },
  {
    name: "追更少女莉莉",
    role: "韩漫爱好者",
    content: "分类做得很细致！我喜欢看恋爱和奇幻类的漫画，网站的分类筛选让我能快速找到想看的作品。推荐算法也很准，经常能发现冷门好作品。",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20avatar%20portrait%20with%20warm%20smile%2C%20modern%20casual%20style%2C%20clean%20minimal%20studio%20lighting%2C%20simple%20soft%20background&width=100&height=100&seq=avatar-002&orientation=squarish",
  },
  {
    name: "漫画评论家老张",
    role: "自媒体人",
    content: "作为一个经常写漫画评论的自媒体人，韩漫漫画网是我获取韩漫资讯的首选平台。文章板块的内容质量也很高，深度分析和文化观察很有参考价值。",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=Middle%20aged%20Asian%20man%20avatar%20portrait%20with%20confident%20expression%2C%20professional%20style%2C%20clean%20minimal%20studio%20lighting%2C%20simple%20neutral%20background&width=100&height=100&seq=avatar-003&orientation=squarish",
  },
];